import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";

import EstudianteConsult from "./EstudianteConsult";

const MainConsultas = (props) => {
    const [valorConsulta, setValorConsulta] = useState({ value: 'estudiantes', label: 'Estudiantes' });

    let valorSelectConsulta = (valorConsulta) => {
        setValorConsulta(valorConsulta)
        props.history.push(`/consultas/${valorConsulta.value}`);
    }

    let valorConsultaLabel = (link) => {
        switch (link) {
            case "/consultas/estudiantes": return('Estudiantes')
            default: return('Estudiantes')
        }
    }

    let contenido = () => (
        <Switch>
            <Route path="/consultas/estudiantes" component={ () => <EstudianteConsult/> } />
            <Redirect to = "/consultas/estudiantes" />
        </Switch>
    )

    let Selecciona = (link) => {
        switch (link) {
            case "/consultas/estudiantes":
                return({ value: 'estudiantes', label: 'Estudiantes' })
            default:
                return({ value: 'estudiantes', label: 'Estudiantes' })
        }
    }

    const Consultas = [
        { value: 'estudiantes', label: 'Estudiantes' },
    ];
    
    return(
        <div className="content">
            <Grid fluid>
                <div className="custom-alert-info" style={{marginBottom:15, padding:10}}>
                    <Row>
                        <Col md={7}>
                            <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                Selecciona el tipo de Solicitud
                            </div>
                        </Col>
                        <Col md={5}>
                            <Select
                                isSearchable ={true}
                                value={Selecciona(props.history.location.pathname)}
                                onChange={valorSelectConsulta}
                                options={Consultas}
                            />
                        </Col>
                    </Row>
                </div>
                <Row>
                    <Col md={12}>
                        <CustomCard
                            title={`Opciones de ${valorConsultaLabel(props.history.location.pathname)}`}
                            category=""
                            color="#a80012"
                            content={contenido()}
                        />
                    </Col>
                </Row>
            </Grid>
        </div>
    )
}

export default MainConsultas;


// WEBPACK FOOTER //
// ./src/views/Consultas/MainConsultas.jsx